import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import PublicView from "./pages/PublicView";
import AdminPage from "./pages/AdminPage";
import LoginPage from "./pages/LoginPage";
import UsersAdminPage from "./pages/UsersAdminPage";
import RegisterNewUser from "./pages/RegisterNewUser";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const isDemo = process.env.REACT_APP_DEMO === "true";

  useEffect(() => {
    if (isDemo) {
      // V demo režimu je uživatel automaticky přihlášen jako admin
      setIsLoggedIn(true);
      setIsAdmin(true);
    } else {
      const loggedIn = localStorage.getItem("loggedIn") === "true";
      const admin = localStorage.getItem("isAdmin") === "true";
      setIsLoggedIn(loggedIn);
      setIsAdmin(admin);
    }
  }, [isDemo]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<PublicView isDemo={isDemo} />} />
        <Route path="/login" element={isDemo ? <Navigate to="/admin" /> : <LoginPage setIsLoggedIn={setIsLoggedIn} setIsAdmin={setIsAdmin} />} />
        <Route path="/admin" element={isLoggedIn ? <AdminPage /> : <Navigate to="/login" />} />
        <Route path="/users" element={isLoggedIn && isAdmin ? <UsersAdminPage /> : <Navigate to="/" />} />
        <Route path="/register" element={isLoggedIn && isAdmin ? <RegisterNewUser /> : <Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
